"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.geofireDatabaseQuery = exports.geofireFirestoreQuery = void 0;
const geofire_common_1 = require("geofire-common");
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const ValidationResult_1 = require("../type-descriptions/ValidationResult");
/**
 * Queries a Firestore collection
 */
async function geofireFirestoreQuery(collection, fieldName, getCoordinatesArray, centerCoordinatesArray, radiusM, firestore, deserialize, shouldIncludeValue) {
    // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
    // a separate query for each pair. There can be up to 9 pairs of bounds
    // depending on overlap, but in most cases there are 4.
    const bounds = (0, geofire_common_1.geohashQueryBounds)(centerCoordinatesArray, radiusM);
    const queryResultsArrays = await Promise.all(bounds.map(([startAt, endAt]) => {
        return firestore.list(collection, {
            orderBy: fieldName,
            startAt,
            endAt,
        });
    }));
    // map
    // filter out false positives (due to geohashes being imprecise)
    const items = new Array();
    queryResultsArrays.forEach(results => {
        results.forEach(result => {
            const coordinatesArray = getCoordinatesArray(result.value);
            const distanceM = (0, geofire_common_1.distanceBetween)(coordinatesArray, centerCoordinatesArray) * 1000;
            if (distanceM <= radiusM) {
                const shouldInclude = shouldIncludeValue ? shouldIncludeValue(result.value) : true;
                if (shouldInclude) {
                    items.push({ distanceM, result });
                }
            }
        });
    });
    // sort
    const sortedItems = (0, sortBy_1.default)(items, ({ distanceM }) => distanceM);
    // map to snapshots
    return sortedItems.map(({ result }) => deserialize(result.value, result.id));
}
exports.geofireFirestoreQuery = geofireFirestoreQuery;
/**
 * Queries a Realtime Database reference
 */
async function geofireDatabaseQuery(collection, fieldName, getCoordinatesArray, centerCoordinatesArray, radiusM, database, description, shouldIncludeValue) {
    // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
    // a separate query for each pair. There can be up to 9 pairs of bounds
    // depending on overlap, but in most cases there are 4.
    const bounds = (0, geofire_common_1.geohashQueryBounds)(centerCoordinatesArray, radiusM);
    const queryResultsArrays = await Promise.all(bounds.map(([startAt, endAt]) => {
        return database.list(collection, {
            orderByChild: fieldName,
            startAt,
            endAt,
        });
    }));
    // map
    // filter out false positives (due to geohashes being imprecise)
    const items = new Array();
    queryResultsArrays.forEach(results => {
        results.forEach(result => {
            const coordinatesArray = getCoordinatesArray(result.value);
            const distanceM = (0, geofire_common_1.distanceBetween)(coordinatesArray, centerCoordinatesArray) * 1000;
            if (distanceM <= radiusM) {
                const shouldInclude = shouldIncludeValue ? shouldIncludeValue(result.value) : true;
                if (shouldInclude) {
                    items.push({ distanceM, result });
                }
                else {
                    // console.log('should not include', result);
                }
            }
            else {
                // console.log('out of bounds', result);
            }
        });
    });
    console.log({ items });
    // sort
    const sortedItems = (0, sortBy_1.default)(items, ({ distanceM }) => distanceM);
    // map to snapshots
    return sortedItems.map(({ result }) => {
        try {
            return (0, ValidationResult_1.validationResultCheck)(description.validate(Object.assign({ id: result.id }, result.value)));
        }
        catch (error) {
            console.log(result);
            throw error;
        }
    });
}
exports.geofireDatabaseQuery = geofireDatabaseQuery;
